import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

const CTASection = () => (
  <section className="py-16 md:py-24 relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-r from-cyan-600 via-blue-600 to-cyan-600 bg-size-200 animate-gradient" />
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" />
      <div
        className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"
        style={{ animationDelay: '1s' }}
      />
    </div>

    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full mb-6">
        <Sparkles className="h-4 w-4 text-white animate-pulse" />
        <span className="text-white text-sm font-medium">Get Started Today</span>
      </div>

      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 leading-snug md:leading-[1.2]">
        Ready to Improve Your Industrial Efficiency?
      </h2>
      <p className="text-base md:text-xl text-white/90 mb-8 md:mb-10">
        Contact us today to discuss your machine guarding, dust suppression or wear resistance requirements
      </p>

      <Link to="/contact" className="group relative inline-flex items-center space-x-2">
        <div className="absolute inset-0 bg-white rounded-xl blur opacity-50 group-hover:opacity-100 transition-opacity" />
        <div className="relative flex items-center space-x-2 bg-white text-cyan-600 px-10 py-5 rounded-xl font-bold text-lg transform group-hover:scale-105 transition-all shadow-2xl">
          <span>Get in Touch</span>
          <ArrowRight className="h-6 w-6 group-hover:translate-x-2 transition-transform" />
        </div>
      </Link>
    </div>
  </section>
);

export default CTASection;
